// https://stackoverflow.com/questions/4565112/javascript-how-to-find-out-if-the-user-browser-is-chrome
const hasWindow = typeof window !== 'undefined'
const hasNavigator = typeof navigator !== 'undefined'
const hasDocument = typeof document !== 'undefined'

export const isUsingBrowser = (browser) => {
  if (!hasNavigator) return false
  return navigator.userAgent.toLowerCase().indexOf(browser.toLowerCase()) > -1
}

// browsers
export const isFirefox = isUsingBrowser('firefox')
export const isChromeBrowser = isUsingBrowser('chrome')
export const isChrome = hasNavigator && /Google Inc/.test(navigator.vendor)
export const isChromeIosBrowser = isUsingBrowser('CriOS')
export const isEdgeBrowser = isUsingBrowser('edge')
export const isCordova = hasWindow && !!window.cordova
export const isIEBrowser = isUsingBrowser('trident')
export const isOperaBrowser = isUsingBrowser('opr')
export const isSafari = isUsingBrowser('safari')

// mobile devices
export const isAndroidDevice = () => isUsingBrowser('android')
export function isIosDevice() {
  if (typeof window === 'undefined') {
    return false
  }
  // see https://github.com/willmcpo/body-scroll-lock/issues/177
  const { platform, maxTouchPoints } = window?.navigator || {}
  return /iP(ad|hone|od)/.test(platform) || (platform === 'MacIntel' && maxTouchPoints > 1)
}

// helpers
export const isTouchScreen = (hasWindow && 'ontouchstart' in window) || (hasWindow && window.DocumentTouch)
export const isWebComponentsSupported =
  hasDocument &&
  'registerElement' in document &&
  'import' in document.createElement('link') &&
  'content' in document.createElement('template')
